import { trackEvent } from "../../analytics/helpers/trackEvent";
import {applySpec, converge, prop, map, path, mergeRight, compose, objOf, always, tap} from 'ramda';
import { GetWindowLanguage } from "../../helpers/storyHelpers";

const ArticleContentProps = applySpec({
  headline: prop('headline'),
  articleDate: prop('article_date'),
  language: GetWindowLanguage,
  articleType: path(['article_type', 'slug']),
  category: path(['category', 'slug']),
  author: compose(map(prop('name')), prop('authors'))
});

const ArticleProps = applySpec({
  id: prop('uuid'),
  slug: prop('slug'),
  tag: prop('tag_list'),
})

const ArticleEventPayload = converge(mergeRight, [
  compose(ArticleContentProps, prop('content')),
  ArticleProps,
])

const trackArticleRead = compose(
  trackEvent,
  applySpec({
    name: always('Article Read'),
    payload: compose(
      objOf('Article'),
      ArticleEventPayload
    )
  })
)

export { trackArticleRead };
